import { generateSlug } from "../../../../../app/src/Utils/utils";

// Mapa slug ↔ id de las secciones (OTT-1966 Fase 2, contrato §4: "section=programas →
// section=12 (slug → id con las secciones recibidas en la respuesta agrupada)"). A diferencia
// de los nodos de filtro, las secciones no tienen endpoint propio: el mapa se reconstruye con
// cada respuesta agrupada (B) que llega, y se conserva mientras el usuario navega.

/** @param {Array<{id:number,name:string}>} sections */
export const buildSectionSlugMap = (sections) => {
  const slugToId = {};
  const idToSlug = {};
  (sections || []).forEach((s) => {
    const slug = generateSlug(s.name || "");
    slugToId[slug] = s.id;
    idToSlug[s.id] = slug;
  });
  return { slugToId, idToSlug };
};

/** Combina un mapa previo con uno nuevo sin perder slugs ya conocidos (p.ej. al volver de
 * una sección la respuesta agrupada puede tardar en llegar). */
export const mergeSectionSlugMaps = (prev, next) => ({
  slugToId: { ...prev.slugToId, ...next.slugToId },
  idToSlug: { ...prev.idToSlug, ...next.idToSlug },
});

export const EMPTY_SECTION_SLUG_MAP = { slugToId: {}, idToSlug: {} };
